import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { plantDockDefaultValues } from "./plantDockDefaultValues";
import { DockForm } from "./DockForm";
import { confirm } from "../../../Layout/Dialog/ConfirmDialog";
import { PlantDock } from "../../PlantDock";
import { SmallAddButton } from "../../../Layout/Buttons/SmallAddButton";
import { useFetchDocksForPlant } from "../../Hooks/useFetchDocksForPlant";
import { useDeleteDock } from "../../Hooks/useDeleteDock";
import { BorderedGridItemWithMessage } from "../../../Grid/BorderedGridItemWithMessage";
import { ReadOnlyProps } from "../../../Project/EditProject/ReadOnlyProps";

type Props = {
  plantId: number;
};

export const DockAccordion = ({ plantId, isReadOnly }: Props & ReadOnlyProps) => {
  const { data: existingDocks, refetch: refetchDocks } = useFetchDocksForPlant(plantId);
  const [docks, setDocks] = useState<PlantDock[]>([]);
  useEffect(() => {
    setDocks(existingDocks ?? []);
  }, [existingDocks]);

  const addDock = (newDock: PlantDock) => {
    setDocks((currentDocks) => [newDock, ...currentDocks]);
  };

  const { mutateAsync: deleteDock } = useDeleteDock();
  const deleteDockWithToast = async (dock: PlantDock) => {
    if (await confirm(`Do you really want to delete dock ${dock.Name}?`)) {
      deleteDock(dock).then(async () => {
        await refetchDocks();
      });
    }
  };

  return (
    <>
      <SmallAddButton
        onClick={() => addDock(plantDockDefaultValues(plantId))}
        disabled={isReadOnly}
      />

      <Grid container>
        <Grid item xs={12} container justifyContent="center">
          {docks.length === 0 ? (
            <BorderedGridItemWithMessage message="No docks exist for this plant yet" />
          ) : (
            docks.map((dock) => (
              <Grid item xs={12} key={dock.Id}>
                <DockForm
                  initialPlantDock={dock}
                  deleteDock={deleteDockWithToast}
                  isReadOnly={isReadOnly}
                />
              </Grid>
            ))
          )}
        </Grid>
      </Grid>
    </>
  );
};
